import { ParametersGlobals } from "./core/parametersGlobals/ParametersGlobals";

var arr = window.location.href.split("/");
var url = arr[0] + "//" + arr[2];
const config: any = {
  url: `${url}`,
  projectName: `${ParametersGlobals.projectTitle}`,
  module_colors: {
    configuracoes: "rgb(75, 57, 105)",
    checklist: "#58a257",
  },
  
  modules: [
    { label: "Configurações", url: "configuracoes", color: "rgb(75, 57, 105)", icon: "fai icon-config", fullName: "Configurações" },
    { label: "Pesquisa de Satisfação", url: "checklist", color: "#58a257", icon: "fas fa-home fa-lg", fullName: "Pesquisa de Satisfação"},
  ],
};

export var getModule = function (moduleName: string) {

  for (const i in config.modules) {
    if (config.modules[i].url === moduleName) {
      return config.modules[i];
    }
  }
  
  for (const i in config.main) {
    if (config.main[i].url === moduleName) {
      return config.main[i];
    }
  }
  
  for (var x in config.bussiness_unities) {
    if (config.bussiness_unities[x].url === moduleName) {
      return config.bussiness_unities[x];
    }
  }
};

export default config;
